import {ProOptions} from 'reactflow';

// Add this as the "proOptions" prop on ReactFlow instances
export const REACT_FLOW_PRO_OPTIONS: ProOptions = {
  account: 'paid-pro',
  hideAttribution: true,
};
